import { atom } from 'jotai';

export const datePeriodLabelAtom = atom<string>('');

export type DateRangeKey =
  | ''
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | 'Past 7 Days'
  | 'Past 30 Days'
  | 'Past 60 Days'
  | 'Past 90 Days'
  | 'MTD'
  | 'Last 1 Month'
  | 'Last 2 Months'
  | 'Last 3 Months'
  | (string & {}); // YYYY-MM for specific month (e.g. "2024-01") when showing 12+ months

export const selectedDatePeriodAtom = atom<DateRangeKey>('MTD');
